import React from "react";
import {
  // HiXCircle,
  ImContrast,
  // MdSkipPrevious,
  // MdExitToApp
} from "react-icons/im";
import { useTranslation } from "react-i18next";

export default function ContrastButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button  is-small modal-button ${
          props.disabled ? "button-disabled" : ""
        }`}
        // onClick={props.onClickHandler}
        title={t("Page Contrast")}
      >
        <span className="has-text-light mr-2">{ t("Page Contrast")}</span>
        <span className="icon  has-text-light">
          <ImContrast className="fas fa-2x" />
        </span>
      </button>
    </>
  );
}
